import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './grid-section.css';

export default class GridSection extends TemplateElement {
    constructor() {
        super({ styles: [style], shadowRender: true });
    }

    template() {
        return html`
            <slot></slot>
        `;
    }
}

defineElement('mb-grid-section', GridSection);
